/* eslint-disable react/prop-types */

import React, { useContext } from 'react';
import { FlexLayout } from '../../components/flex/FlexLayout.component';
import { FlexItem } from '../../components/flex/FlexItem.component';
import { FlexLayoutModifier } from '../../components/flex/flex.constants';
import { AssessmentGoalDto } from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import {
  RemediationActivityTypeDto,
} from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import {
  getActivityTypeTitle,
  getRequirementSubtitle
} from './remediation-student-activity.utilities';
import { AppContext } from '../../components/app/AppProvider.component';
import {
  getContentTypeMainDisplay,
  getContentTypesFromActivityType,
  getMetricCounts,
  getProgressDisplay
} from '../../utilities/remediation.utilities';
import { ActivityProgressBar } from '../../components/activity-progress-bar/ActivityProgressBar.component';

export type ActivityProgressOverviewProps = {
  assessmentGoals: AssessmentGoalDto[];
  activityType: RemediationActivityTypeDto;
};

const ActivityProgressOverview = (props: ActivityProgressOverviewProps): JSX.Element => {
  const { appState } = useContext(AppContext);
  const baseState = appState.remediationBaseState;

  const {
    assessmentGoals,
    activityType
  } = props;

  if (!activityType || !baseState) {
    return null;
  }

  const metricCounts = getMetricCounts(baseState, activityType);

  const progressDisplay = getProgressDisplay(metricCounts, activityType);
  const contentTypes = getContentTypesFromActivityType(activityType, baseState);
  const contentTypesDisplay = getContentTypeMainDisplay(contentTypes, null);

  return (
    <div
      className="c-nra-activity-progress-overview__summary"
    >
      <div className="u-els-padding-1x c-nra-activity-progress-overview__summary-requirement">
        <FlexLayout>
          <FlexItem
            modifiers={[
              FlexLayoutModifier.GROW,
            ]}>
            <span className="u-els-font-size-body-large u-els-bold">{getActivityTypeTitle(activityType, contentTypesDisplay)}</span>
          </FlexItem>
        </FlexLayout>
        <span className="u-els-color-n7">
          {getRequirementSubtitle(baseState?.remediationAssignmentWithSources, assessmentGoals, activityType, metricCounts, contentTypesDisplay)}
        </span>
      </div>

      <div className="c-nra-remediation-student-activity__divider"/>

      <div className="u-els-padding-1x">
        <FlexLayout modifiers={[
          FlexLayoutModifier.GUTTERS_1o2,
          FlexLayoutModifier.MIDDLE
        ]}>
          <FlexItem
            classes={['u-els-margin-right-1x']}
            modifiers={[
              FlexLayoutModifier.GROW,
            ]}>
            <ActivityProgressBar metricCounts={metricCounts} activityType={activityType}/>
          </FlexItem>
          <FlexItem>
            <span className="u-els-color-n7">{progressDisplay}</span>
          </FlexItem>
        </FlexLayout>
      </div>
    </div>
  );
};
export default ActivityProgressOverview;
